var _circle, _path, _circle2, _path2, _rect, _rect2, _g, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconpause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "#8c8cf0",
    className: "fill-93b5e1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 32a30 30 0 0 1-60 0c0-.49.01-.98.04-1.46a30 30 0 0 0 59.92 0c.03.48.04.97.04 1.46Z",
    opacity: 0.15,
    fill: "#8c8cf0",
    className: "fill-000000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24,
    fill: "#848ccf",
    className: "fill-848ccf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56 32a24 24 0 0 1-48 0c0-.51.02-1.01.05-1.5a23.997 23.997 0 0 0 47.9 0c.03.49.05.99.05 1.5Z",
    opacity: 0.15,
    fill: "#8c8cf0",
    className: "fill-000000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 26,
    rx: 1,
    width: 8,
    x: 21,
    y: 19,
    fill: "#ffffff",
    className: "fill-ffffff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    height: 26,
    rx: 1,
    width: 8,
    x: 35,
    y: 19,
    fill: "#ffffff",
    className: "fill-ffffff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 41v3a1.003 1.003 0 0 1-1 1h-6a1.003 1.003 0 0 1-1-1v-3a1.003 1.003 0 0 0 1 1h6a1.003 1.003 0 0 0 1-1ZM43 41v3a1.003 1.003 0 0 1-1 1h-6a1.003 1.003 0 0 1-1-1v-3a1.003 1.003 0 0 0 1 1h6a1.003 1.003 0 0 0 1-1Z",
    fill: "#8c8cf0",
    className: "fill-000000"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 2a30 30 0 1 0 30 30A30.034 30.034 0 0 0 32 2Zm0 58a28 28 0 1 1 28-28 28.031 28.031 0 0 1-28 28Z",
    fill: "#7070eb",
    className: "fill-3282b8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 8a24 24 0 1 0 24 24A24.027 24.027 0 0 0 32 8Zm0 46a22 22 0 1 1 22-22 22.025 22.025 0 0 1-22 22Z",
    fill: "#7070eb",
    className: "fill-3282b8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28 19h-6a1 1 0 0 0-1 1v24a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V20a1 1 0 0 0-1-1Zm-1 24h-4V21h4ZM42 19h-6a1 1 0 0 0-1 1v24a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V20a1 1 0 0 0-1-1Zm-1 24h-4V21h4Z",
    fill: "#7070eb",
    className: "fill-3282b8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconpause);
export default __webpack_public_path__ + "static/media/iconpause.2aa8b9e52ce4543293f2ee67e639e318.svg";
export { ForwardRef as ReactComponent };